export default __webpack_public_path__ + "static/media/clientCase6.609ad092.png";